import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {UserImportRepository} from '../repositories/user-import.repository';

@Injectable()
export class UserImportService {

  constructor(private userImportRepository: UserImportRepository) { }

  public startImport(file: File): Observable<Response> {
    return this.userImportRepository.startImport(file);
  }

  public getSampleCSV(): Observable<Blob> {
    return this.userImportRepository.getSampleCSV();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-import/services/user-import.service.ts